import React from "react";
import { Navigate } from "react-router-dom";

const ProtectedRoute = ({ children, user, auth }) => {
  return !auth ? <Navigate to="/login" /> : children;
};

export default ProtectedRoute;
